import { useCallback, useEffect, useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { Button, Col, Form, Row } from "reactstrap";
import SubjectFilter from "./SubjectFilter";
import "../../../../styles/filters.scss";
import ContentsFilter from "./StateFilter";
import CompanyFilter from "./CompanyFilter";
import SeniorityFilter from "./SeniorityFilter";

const Filters = (props: any) => {
  const { setFilters, filtersData } = props;
  const [reset, setReset] = useState(false);

  const handleNameChange = useCallback((event: any) => {
    setFilters((prev: any) => {
      return { ...prev, nom: event };
    });
  }, []);
  const handleSujetsChange = useCallback((subjects: any) => {
    setFilters((prev: any) => {
      return { ...prev, sujets: subjects };
    });
  }, []);
  const handleCompanyChange = useCallback((company: any) => {
    setFilters((prev: any) => {
      return { ...prev, entreprise: company };
    });
  }, []);
  const handleSeniorityChange = useCallback((seniority: any) => {
    setFilters((prev: any) => {
      return { ...prev, exp: seniority };
    });
  }, []);
  const handleContentChange = useCallback((content: any) => {
    setFilters((prev: any) => {
      return { ...prev, etat: content };
    });
  }, []);

  const [name, setName] = useState<string>("");

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      handleNameChange(name);
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
  }, [name, handleNameChange]);

  return (
    <Form>
      <Row>
        <Col lg="12">
          <input
            name="title"
            placeholder="Rechercher un relecteur"
            className="formControl label-search ps-3"
            onChange={(e) => setName(e.target.value.trim().toLowerCase())}
          />
          <AiOutlineSearch
            className="formSearchIconEnd"
            size={17}
            color="#3367cd"
          ></AiOutlineSearch>
        </Col>
      </Row>
      <Row className="my-3">
        <Col md="2">
          <SeniorityFilter
            handleChange={handleSeniorityChange}
            reset={reset}
          ></SeniorityFilter>
        </Col>
        <Col md="2">
          <CompanyFilter
            handleChange={handleCompanyChange}
            reset={reset}
          ></CompanyFilter>
        </Col>
        <Col md="2">
          <SubjectFilter
            handleChange={handleSujetsChange}
            reset={reset}
          ></SubjectFilter>
        </Col>

        <Col md="2">
          <ContentsFilter
            handleChange={handleContentChange}
            reset={reset}
          ></ContentsFilter>
        </Col>
        <Col md="2">
          <Button
            className="btn-round-sm-secondary ms-2 validate mt-0"
            color="primary"
            onClick={() => {
              setReset(true);
              setFilters(filtersData);
            }}
          >
            Réinitialiser
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default Filters;
